import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SistemasService } from '../../services/sistemas.service';
import { AuthService } from '../../services/auth.service';

import { UsuarioBc } from '../../model/usuario-bc';
import { StorageService } from '../../services/storage.service';
import {REDIRECT_URL} from "../../util/constants";

@Component({
  selector: 'app-detalhe',
  templateUrl: './detalhe.component.html',
  styleUrls: ['./detalhe.component.scss']
})
export class DetalheComponent implements OnInit {

  carregando = true;
  aplicativo: any;
  idAplicativo: any;
  searchText = '';
  usuarioLogado: UsuarioBc;
  showModalAdicionarAlerta = false;
  showModalAvisoAlerta = false;
  showModalAvisoAlertaIsOuro = false;
  isOuro:any =false;
  tituloAviso = '';
  textoAviso = '';
  conteudoAviso = '';
  downloadsAviso = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sistemasService: SistemasService,
    private authService: AuthService,
    private storage: StorageService
  ) { }

  async ngOnInit() {
    const showAlertNotOuro = localStorage.getItem('REDIRECT_NOT_OURO') === 'true';
    if(showAlertNotOuro){
      this.tituloAviso = 'Atenção!';
      this.conteudoAviso =  "Para acessar esta funcionalidade, é necessário possuir o selo ouro no Gov.br. Verifique sua autenticação para continuar.<br><br> <a href='https://www.gov.br/governodigital/pt-br/identidade/conta-gov-br/niveis-da-conta-govbr/saiba-mais-sobre-os-niveis-da-conta-govbr' target='_blank'>Saiba mais sobre os níveis da conta</a>";
      this.showModalAvisoAlertaIsOuro = true;
      localStorage.removeItem('REDIRECT_NOT_OURO');
    }
    this.route.paramMap.subscribe(params => {
      this.idAplicativo = params.get('id');
    });
    const registros = await this.sistemasService.get(this.idAplicativo);
    //console.log('registros: ', registros);
    const arraySplit = registros[0].imagem.url.split('http://');
    if (arraySplit.length > 1) {
      registros[0].imagem.url = 'https://' + arraySplit[1];
    }
    this.aplicativo = registros[0];
    console.log('aplicativo', this.aplicativo);
    this.carregando = false;

    this.isOuro = await this.authService.buscarConfiabilidade();


  }

  toggleAccordion(modulo: any) {
    if (!modulo.ativo) { this.scrollTo(modulo.objectId); }
    this.menuPosition(modulo.objectId);
    modulo.ativo = !modulo.ativo;
  }

  async abrirSolicitarAcesso(app) {

    localStorage.setItem('URL_SOLICITACAO_ACESSO', '/solicitacao-de-acesso');
    localStorage.setItem('LOGIN_BY_SOLICITACAO_ACESSO', 'SIM');
    this.storage.setCurrentApp(JSON.stringify(app));
    // if (production) {
    if (this.verificarUsuarioLogado()) {
      if(this.isOuro) {
        this.removeStorage();
        this.router.navigateByUrl('/solicitacao-de-acesso');
      }else{
        this.abreModalAvisoSeloOuro();
     
      }
     
    } else {
      this.logar();
    }
    // } else {
    //   this.removeStorage();
    //   this.router.navigateByUrl('/solicitacao-de-acesso');
    // }
  }

  abrirModalAcesso() {

    if(this.isOuro) {
      if (this.aplicativo.textoAlerta) {
        this.showModalAdicionarAlerta = true;
      }
    }else{
      this.abreModalAvisoSeloOuro();
    }


    
  }

  removeStorage() {
    localStorage.removeItem('current-solicitacao');
    localStorage.removeItem('current-estabelecimento');
    localStorage.removeItem('current-responsavel');
    localStorage.removeItem('filhos');
    localStorage.removeItem('esus');
    localStorage.removeItem('sistemas');
  }

  logar() {
    localStorage.setItem('URL_DETALHE', this.router.url);
    
    const redirectUrl = `${REDIRECT_URL}`;
    this.authService.loginBrasilCidadao(redirectUrl);
   
  }

  verificarUsuarioLogado() {
    const isLogado = this.authService.existeUsuarioLogado();
    this.usuarioLogado = this.authService.getUsuarioLogado();
    return isLogado && this.usuarioLogado;
  }

  scrollTo(id: string) {
    const element = document.getElementById('conteudo-' + id);
    const y = element.getBoundingClientRect().top + window.pageYOffset - 60;
    window.scrollTo({ top: y, behavior: 'smooth' });

    this.menuPosition(id);
  }

  menuPosition(id: string) {
    const linhaMovel = document.getElementById('linha-movel');
    const menu = document.getElementById('menu-sidebar');
    const menuItem = document.getElementById('menu-' + id);

    if (menuItem == null) {
      return;
    }
    linhaMovel.style.top = menuItem.getBoundingClientRect().top - menu.getBoundingClientRect().top + 6 + 'px';
  }

  fecharModalAdicionarAlerta(data) {
    this.showModalAdicionarAlerta = false;
  }

  fecharModalAvisoAlerta(data) {
    this.showModalAvisoAlerta = false;
  }
  fecharModalAvisoAlertaIsOuro(data) {
    this.showModalAvisoAlertaIsOuro = false;
  }

  abreModalAviso(id, submodulo, modulo) {
    this.showModalAvisoAlerta = true;
    this.tituloAviso = modulo.titulo;
    this.textoAviso = submodulo.titulo;
    this.conteudoAviso = submodulo.conteudo;
    this.downloadsAviso = submodulo.downloads;
    // this.linhaMovelAvisoPosition(id);
  }

  abreModalAvisoSeloOuro() {
    
    this.showModalAvisoAlertaIsOuro = true;
    this.tituloAviso = 'Atenção!';
    this.conteudoAviso =  "Para acessar esta funcionalidade, é necessário possuir o selo ouro no Gov.br. Verifique sua autenticação para continuar.<br><br> <a href='https://www.gov.br/governodigital/pt-br/identidade/conta-gov-br/niveis-da-conta-govbr/saiba-mais-sobre-os-niveis-da-conta-govbr' target='_blank'>Saiba mais sobre os níveis da conta</a>";
    //this.conteudoAviso = submodulo.conteudo;
    //this.downloadsAviso = submodulo.downloads;
    // this.linhaMovelAvisoPosition(id);
  }

  linhaMovelAvisoPosition(id: string) {
    const linhaMovelAviso = document.getElementById('linha-movel-aviso');
    // const menu = document.getElementById('menu-sidebar');
    const liItem = document.getElementById('li-' + id);
    if (liItem == null) {
      return;
    }
    linhaMovelAviso.style.top = liItem.getBoundingClientRect().top - 155 + 'px';
  }

  pegaTamanhoDiv(modulo) {

    if (modulo.subModulos.length < 2) {
      return {
        'height': '50px !important;'
      };
    } else {
      return {
        'height': '200px !important;'
      };
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/detalhe/detalhe.component.ts